<script setup lang="ts">
defineProps<{ group: string }>();

/** Map a group id to a pill CSS modifier. */
function pillClass(g: string): string {
  const lower = g.toLowerCase();
  if (lower.includes("cats")) return "pill pill--cats";
  if (lower.includes("dogs")) return "pill pill--dogs";
  if (lower.includes("public")) return "pill pill--public";
  if (lower.startsWith("entra:")) return "pill pill--entra";
  return "pill pill--other";
}

function label(g: string): string {
  if (g.startsWith("group:")) return g.slice(6);
  if (g.startsWith("entra:")) return `entra:${g.slice(6, 12)}…`;
  return g;
}
</script>

<template>
  <span :class="pillClass(group)" :title="group">{{ label(group) }}</span>
</template>
